import React, { FC, createContext, useState, useEffect } from "react";
import { io, Socket } from "socket.io-client";
import { ICard, IJoinRoomSpectator, IMessage } from "../interfaces";
const ENDPOINT = process.env.REACT_APP_BACKEND_URL;

interface ISocketContext {
  socket?: Socket;
  newRandomStrengthCard: any;
  spinNumberData: any;
  isSpinClicked: boolean;
  chatMessages: IMessage[];
  isProfilePictureUpdated: boolean;
  theSolutionCardSelectedByDilemmaOwner: any;
  isActionDoneButtonRevealed: boolean; 
  nextPhaseConffeti(delay: number): void;
  startSpinSocketEvent(userEmail: string): void;
  generateRandomStrengthCardsSocketEvent(): void;
  callFacilitatorEmit(gameId: any): void;
  finishChoosingCardsSocketEvent(): void;
  openNewSolutionCardSocketEvent(type: string): void;
  changeSoultionCardSocketEvent(type: string): void;
  drawDilemmaCardSocketEvent(type: string): void;
  finishActionCardSocketEvent(): void;
  dropStrengthCardSocketEvent(id: number | undefined): void;
  tipPlayerSocketEmit(tippedPlayerEmail: string): void;
  saveStrengthImagesSocketEvent(id: number | undefined, image: any): void;
  finishIntroductionSocketEvent(): void;
  chooseOneOfProposedCardsSocketEvent(id: number | string | undefined, email: string, image: any): void;
  dilemmaOwnerPickedASolutionSocketEvent(id?: number | string | undefined): void;
  proposeSolutionCardSocketEvent(id: number | string | undefined, type: string): void;
  withdrawCardSocketEvent(): void;
  skipDillemaCardSocketEvent(): void;
  activateJokerButtonSocketEvent(): void;
  refreshTimerSocket(): void;
  revealDoneButtonSocketOn(): void;
  profilePicturesNeedUpdateSocketOn(): void;
  setAreSolutionCardsDrawn(): void;
  randomOneStrengthCardSocketOn(): void;
  finishedChoosingDilemmaCardSocketEmit(): void;
  solutionCardSelectedSocketOn(): void;
  spinNumberSocketOn(): void;
  setIsSpinClicked(isSpinClicked: boolean): void;
  chatSocketOn(): void;
  forceRefreshPlayer(): void;
  chatSocketOff(): void;
  setChatMessages(chatMessages: IMessage[]): void;
  timeParser(a: any): any;
  setSpinNumberData(spinNumberData: any): void;
  setIsProfilePictureUpdated(isProfilePictureUpdated: boolean): void;
  triggerConfetti(): void;
  playCheeringSound(sound: string): void;
  setTheSolutionCardSelectedByDilemmaOwner(theSolutionCardSelectedByDilemmaOwner: any): void;
  setIsActionDoneButtonRevealed(isActionDonebuttonRevealed: boolean): void;
  
}

const SocketContext = createContext({} as ISocketContext);

interface SocketContextProps {
  children: React.ReactNode;
}

const SocketContextProvider: FC<SocketContextProps> = (props) => {
  const [socket, setSocket] = useState<Socket | undefined>();
  const [newRandomStrengthCard, setNewRandomStrengthCard] = useState<any>();
  const [isSpinClicked, setIsSpinClicked] = useState<boolean>(false);
  const [spinNumberData, setSpinNumberData] = useState();
  const [chatMessages, setChatMessages] = useState<IMessage[]>([]);
  const [isProfilePictureUpdated, setIsProfilePictureUpdated] = useState<boolean>(false);
  const [theSolutionCardSelectedByDilemmaOwner, setTheSolutionCardSelectedByDilemmaOwner] = useState();
  const [isActionDoneButtonRevealed, setIsActionDoneButtonRevealed] = useState<boolean>(false);

  useEffect(() => {

    const registerAlleEvents = (socket: Socket) => {
      registerDisconnection(socket);
    };

    const initialiseSocket = () => {
      let newSocket: Socket = io(ENDPOINT || "");

      registerAlleEvents(newSocket);

      setSocket(newSocket);
    };

    if (!socket)
      initialiseSocket();
  }, [socket]);

  const registerDisconnection = (socket: Socket) => {
    socket.on("disconnect", (result: any) => {
      if (result === "transport close" || result === "ping timeout") {
        window.location.reload();
      }
    });
  };

  const startSpinSocketEvent = (userEmail: string) => {
    socket?.emit("startSpin", {email: userEmail});
  }

  const callFacilitatorEmit = (gameId: any) => {
    socket?.emit( "callFacilitator", {gameId: gameId})
  }
  //not used
  const generateRandomStrengthCardsSocketEvent = () => {
    socket?.emit("generateRandomStrengthCards");
  }
  //not used
  const finishChoosingCardsSocketEvent = () => {
    socket?.emit("finishChoosingCards");
  }

  const openNewSolutionCardSocketEvent = (type: string) => {
    socket?.emit("openNewSolutionCard", { type: type });
  }

  const changeSoultionCardSocketEvent = (type: string) => {
    socket?.emit("changeSolutionCard", { type })
  }

  const drawDilemmaCardSocketEvent = (type: string) => {
    socket?.emit("drawDilemmaCard", { type: type });
  }

  const finishActionCardSocketEvent = () => {
    socket?.emit("finishActionCard");
  }
  //not used
  const dropStrengthCardSocketEvent = (id: number | undefined) => {
    socket?.emit("dropStrengthCard", { id: id })
  }

  const saveStrengthImagesSocketEvent = (id: number | undefined, image: any) => {
    socket?.emit("saveStrengthImages", { id: id, image: image });
  }

  const finishIntroductionSocketEvent = () =>{
    socket?.emit("finishIntroduction");
  }

  const chooseOneOfProposedCardsSocketEvent = (id: number | undefined, email: string, image: any) => {
    socket?.emit("chooseOneOfProposedCards", { strengthId: id, email: email, image: image })
  }

  const dilemmaOwnerPickedASolutionSocketEvent = (cardId: number | undefined) => {
    socket?.emit("dilemmaOwnerPickedASolution", {cardId: cardId});
  }
//tag
  const proposeSolutionCardSocketEvent = (id: any, type: string) => {
    socket?.emit("proposeSolutionCard", { _id: id, type: type });
  }

  const withdrawCardSocketEvent = () => {
    socket?.emit("withdrawSolutionCard");
  }

  const skipDillemaCardSocketEvent = () => {
    socket?.emit("skipDillemaCard");
  }

  const activateJokerButtonSocketEvent = () => {
    socket?.emit("activateJokerButton");
  }

  const refreshTimerSocket = () => {
    socket?.emit("refreshTimer");
  }

  const revealDoneButtonSocketOn = () => {
    socket?.on("revealDoneButton", data => {
      if (!isActionDoneButtonRevealed) 
        setIsActionDoneButtonRevealed(true);
    }) 
  }

  const profilePicturesNeedUpdateSocketOn = () => {
    socket?.on("profilePicturesNeedUpdate", (data: any) => {
      setIsProfilePictureUpdated(!isProfilePictureUpdated);
    })
  }

  const setAreSolutionCardsDrawn = () => {
    socket?.emit("setAreSolutionCardsDrawn", { areSolutionCardsDrawn: true });
  }

  const randomOneStrengthCardSocketOn = () => {
    socket?.on("randomOneStrengthCard", data => {
      setNewRandomStrengthCard (data);
    });
  }

  const finishedChoosingDilemmaCardSocketEmit = () => {
    socket?.emit("finishedChoosingDilemmaCard");
  }

  const solutionCardSelectedSocketOn = () => {
    socket?.on("solutionCardSelected", data => {
      setTheSolutionCardSelectedByDilemmaOwner(data);
      console.log("data number one:", data);
    })
  }

  const tipPlayerSocketEmit = (tippedPlayerEmail: string) => {
    socket?.emit("tipPlayer", {tippedPlayerEmail: tippedPlayerEmail});
  }

  const spinNumberSocketOn = () => {
    socket?.on("spinNumber", data => {
      setTimeout(() => {
        setIsSpinClicked(true);
      }, 5000);
      setSpinNumberData(data);
    });

    return () => {
      socket?.off("spinNumber");
    }
  }

  const chatSocketOn = () => {
    if (socket?.hasListeners("chat"))
      return;

    socket?.on("chat", (data: any) => {      
      const recievedDate = new Date(data.date);
      const formatedDate =
        timeParser(recievedDate.getHours()) + ":" + timeParser(recievedDate.getMinutes());

      const recievedData: IMessage = {
        date: formatedDate,
        name: data.nickname || "",
        message: data.message,
        email: data.email,
        float: "floatLeft",
      };
      setChatMessages([...chatMessages, recievedData]);
    });
  }

  const forceRefreshPlayer = () => {
    if (socket?.hasListeners("forceRefresh"))
      return;
      
    socket?.on("forceRefresh", (data: any) => {
        if( data?.email == localStorage["userEmailInCaseHeLogsOut"]){
          window.location.reload();
        }
        if (data?.email == "all") {
          window.location.reload();
        }
    });
  }

  const chatSocketOff = () => {
    socket?.off("chat");
  }

  const timeParser = (a: any) => {
    if (a.toString().length < 2) return "0" + a;
    return a;
  }

  const nextPhaseConffeti = (delay: number) => {
    socket?.emit("nextPhase", { delay });
  }

  const triggerConfetti = () => {
    socket?.emit("celebrate");
  }

  const playCheeringSound = (sound: string) => {
    socket?.emit("playSound", sound);
  }

  const providerValue = {
    socket,
    newRandomStrengthCard,
    spinNumberData,
    isSpinClicked,
    chatMessages,
    isProfilePictureUpdated,
    theSolutionCardSelectedByDilemmaOwner, 
    isActionDoneButtonRevealed, 
    playCheeringSound,
    startSpinSocketEvent,
    generateRandomStrengthCardsSocketEvent,
    callFacilitatorEmit,
    finishChoosingCardsSocketEvent,
    openNewSolutionCardSocketEvent,
    changeSoultionCardSocketEvent,
    drawDilemmaCardSocketEvent,
    finishActionCardSocketEvent,
    nextPhaseConffeti,
    dropStrengthCardSocketEvent,
    saveStrengthImagesSocketEvent,
    chooseOneOfProposedCardsSocketEvent,
    finishIntroductionSocketEvent,
    dilemmaOwnerPickedASolutionSocketEvent,
    proposeSolutionCardSocketEvent,
    withdrawCardSocketEvent,
    skipDillemaCardSocketEvent,
    activateJokerButtonSocketEvent,
    refreshTimerSocket,
    revealDoneButtonSocketOn,
    profilePicturesNeedUpdateSocketOn,
    setAreSolutionCardsDrawn,
    randomOneStrengthCardSocketOn,
    finishedChoosingDilemmaCardSocketEmit,
    solutionCardSelectedSocketOn,
    tipPlayerSocketEmit,
    spinNumberSocketOn,
    setIsSpinClicked,
    chatSocketOn,
    forceRefreshPlayer,
    chatSocketOff,
    setChatMessages,
    timeParser,
    setSpinNumberData,
    setIsProfilePictureUpdated,
    triggerConfetti,
    setTheSolutionCardSelectedByDilemmaOwner,
    setIsActionDoneButtonRevealed
  };

  return (
    <SocketContext.Provider value={providerValue}>
      {props.children}
    </SocketContext.Provider>
  );
};

export { SocketContext, SocketContextProvider };
